import { Observable } from 'rxjs';

import { Department, DepartmentCreateParams, DepartmentUpdateParams } from '../models/department.model';

export abstract class DepartmentGateway {
  abstract createDepartment(params: DepartmentCreateParams): Observable<Department>;
  abstract getDepartment(organizationId: string): Observable<Department>;
  abstract updateDepartment(organizationId: string, params: DepartmentUpdateParams): Observable<Department>;
}
